import './styles.css'

angular.module('shared-components').component('gccsTextTooltip', {
  controller: function () {},
  template: require('./template.pug'),
  bindings: {
    text: '@'
  }
});
